export interface Exercise {
  id: number
  name: string
  reps: number
  instructions?: string
  imageUrl?: string
  defaultPacingSpeed?: number
}
export const exercises: Exercise[] = [
  {
    id: 1,
    name: 'Horse Stance',
    reps: 100,
    instructions:
      'Stand with feet wider than shoulder-width apart, toes pointing slightly outward. Bend your knees and sink down as if sitting on a horse. Keep your back straight and hold the position.',
    imageUrl:
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 30,
  },
  {
    id: 2,
    name: 'Fire Wheel',
    reps: 20,
    instructions:
      'Stand with feet shoulder-width apart. Rotate your arms in large circular motions while engaging your core and maintaining proper posture.',
    imageUrl:
      'https://images.unsplash.com/photo-1594737625785-a6cbdabd333c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 20,
  },
  {
    id: 3,
    name: 'Full Body Flow',
    reps: 20,
    instructions:
      'Begin in a standing position. Flow through a sequence of movements that engage your entire body, moving with intention and breath awareness.',
    imageUrl:
      'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 15,
  },
  {
    id: 4,
    name: 'Soaring Eagle',
    reps: 50,
    instructions:
      'Stand tall with arms at your sides. Raise your arms out to the sides and up, mimicking the wings of an eagle. Engage your back muscles and maintain proper posture.',
    imageUrl:
      'https://images.unsplash.com/photo-1518611012118-696072aa579a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 25,
  },
  {
    id: 5,
    name: 'Spinal Wheel Rotation',
    reps: 30,
    instructions:
      'Stand with feet hip-width apart. Place hands on hips and rotate your torso in circular motions, focusing on articulating through each vertebra of the spine.',
    imageUrl:
      'https://images.unsplash.com/photo-1616699002805-0741e1e4a9c5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 20,
  },
  {
    id: 6,
    name: 'Lunge Twists',
    reps: 20,
    instructions:
      'Step forward into a lunge position. Twist your torso toward the front leg, then return to center and switch sides.',
    imageUrl:
      'https://images.unsplash.com/photo-1581009137042-c552e485697a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 15,
  },
  {
    id: 7,
    name: 'Horse Stance Side Stretch',
    reps: 20,
    instructions:
      'Begin in horse stance. Extend one arm overhead and lean to the opposite side for a deep stretch. Return to center and repeat on the other side.',
    imageUrl:
      'https://images.unsplash.com/photo-1518459031867-a89b944bffe4?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 20,
  },
  {
    id: 8,
    name: 'Horse Stance Forward Bend',
    reps: 50,
    instructions:
      'From horse stance, hinge at the hips and bend forward, keeping your back flat. Return to upright position and repeat.',
    imageUrl:
      'https://images.unsplash.com/photo-1566241142559-40e1dab266c6?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 25,
  },
  {
    id: 9,
    name: 'Waist Rotation',
    reps: 20,
    instructions:
      'Stand with feet hip-width apart. Place hands on waist and rotate your hips in circular motions, focusing on isolating the movement to your waist.',
    imageUrl:
      'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 30,
  },
  {
    id: 10,
    name: 'Side Stretch',
    reps: 20,
    instructions:
      'Stand tall with feet hip-width apart. Raise one arm overhead and lean to the opposite side, creating a deep stretch along the side of your body. Return to center and switch sides.',
    imageUrl:
      'https://images.unsplash.com/photo-1562771379-eafdca7a02f8?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 20,
  },
  {
    id: 11,
    name: 'Dragon Twist',
    reps: 20,
    instructions:
      'Begin in a lunge position. Place opposite elbow to front knee and rotate your torso, extending the other arm upward. Return to center and switch sides.',
    imageUrl:
      'https://images.unsplash.com/photo-1604431696980-312072e42b90?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 15,
  },
  {
    id: 12,
    name: 'Piercing the Moon',
    reps: 20,
    instructions:
      'Stand with feet shoulder-width apart. Reach both arms overhead, interlacing fingers with index fingers extended. Stretch upward as if piercing the moon.',
    imageUrl:
      'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 20,
  },
  {
    id: 13,
    name: 'Flood Dragon Flow',
    reps: 20,
    instructions:
      'Begin in a standing position. Flow through a series of fluid, wave-like movements that mimic the motion of a dragon moving through water.',
    imageUrl:
      'https://images.unsplash.com/photo-1601422407692-ec4eeec1d9b3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    defaultPacingSpeed: 15,
  },
]
